import { render, staticRenderFns } from "./SeminarAdministration.vue?vue&type=template&id=33adda46&"
import script from "./SeminarAdministration.vue?vue&type=script&lang=js&"
export * from "./SeminarAdministration.vue?vue&type=script&lang=js&"
import style0 from "./SeminarAdministration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports